<style scoped>
.v-application .text-h5 {
  font-family: "Prompt", sans-serif !important;
  font-size: 24px !important;
}
.text-spacing {
  letter-spacing: 0px !important;
}
.v-application .white {
  border: #ccd0d9 solid 1px !important;
}
input.mx-input {
  height: 40px !important;
}
</style>

<template>
  <div>
    <v-dialog v-model="dialog" max-width="640">
      <v-card>
        <v-card-title
          class="text-h5 font-weight-black info--text text-spacing"
          color="blue"
        >
          ส่งอีเมลล์แบบฟอร์ม {{ header }}
        </v-card-title>
        <v-card-text>
          <v-divider></v-divider>
          <v-row justify="center">
            <v-col cols="12" lg="12">
              <v-row justify="center">
                <v-col cols="12" lg="10" class="mb-n10 mt-n5">
                  <span class="email-text">จาก :</span>
                  <v-text-field dense outlined v-model="Esender"></v-text-field>
                </v-col>
                <v-col cols="12" lg="10" class="mb-n10">
                  <span class="email-text">ถึง :</span>
                  <v-text-field
                    dense
                    outlined
                    v-model="Ereciever"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" lg="10" class="mb-n10">
                  <span class="email-text">หัวข้อ :</span>
                  <v-text-field dense outlined v-model="Eheader"></v-text-field>
                </v-col>
                <v-col cols="12" lg="10" class="my-n2"> </v-col>
                <v-col cols="12" lg="10" class="mt-n2">
                  <span class="email-text">ข้อความ :</span>
                  <v-textarea
                    row-height="5"
                    dense
                    outlined
                    v-model="Emessage"
                  ></v-textarea>
                </v-col>
                <v-col cols="12" lg="10" class="mt-n5">
                  <v-btn color="primary" width="100%" @click="sendemail()">
                    ส่งอีเมลล์
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>

import { mapGetters, mapMutations } from 'vuex'

export default {
  name: "EmailModal",
  props: {
    Page: String,
  },
  components: {
  },
  data() {
    return {
      header: "",
      dialog: false,
      Esender: "newchok.2019@gmail.com",
      Ereciever: "",
      Eheader: "",
      Emessage: "",
      apiUrl: "",
      email_obj: {}
      // list_days:[]
    };
  },
  computed: {
    ...mapGetters({
      myState: 'CustomerDetail/GET_DAYS',
      cusData: 'CustomerDetail/GET_CUSTOMER',
    }),
  },
  filters: {

  },
  watch: {

  },
  mounted() {


  },
  created() {


  },
  methods: {
    ...mapMutations({
      LOADER: "Drawer/SET_LOADER",
    }),
    openModal(TableData) {
      this.dialog = true
      if (this.Page == 'Quotation') {
        this.header = `ใบเสนอราคา ${TableData.qt_id}`
        this.Ereciever = TableData.PROVIDER_EMAIL
        this.Eheader = `เอกสารเสนอราคา ${TableData.qt_id}`
        this.Emessage = `เรียน  ${TableData.CUSTOMER_NAME}${'\n'}${'\n'}${this.$AppName.limited_company} ได้แนบเอกสาร เลขที่ ${TableData.qt_id} มาให้ในอีเมลนี้${'\n'}${'\n'}กรุณาคลิกที่ไฟล์แนบ เพื่อดาวน์โหลดเอกสารของคุณ${'\n'}${'\n'}ด้วยความเคารพ ${this.$AppName.limited_company}`
        this.apiUrl = `/send-quotation-email`
        this.email_obj = {
          QUOTATION_ID: TableData.qt_id,
          email_sender: this.Esender,
          email_reciever: this.Ereciever,
          email_header: this.Eheader,
          email_content: this.Emessage,
          pdf_file: "",
          file_name: ""
        }
      } else if (this.Page == 'Bill') {
        this.header = `ใบวางบิล​/แจ้งหนี้ ${TableData.BILL_ID}`
        this.Ereciever = TableData.PROVIDER_EMAIL
        this.Eheader = `เอกสารวางบิล​/แจ้งหนี้ ${TableData.BILL_ID}`
        this.Emessage = `เรียน  ${TableData.CUSTOMER_NAME}${'\n'}${'\n'}${this.$AppName.limited_company} ได้แนบเอกสาร เลขที่ ${TableData.BILL_ID} มาให้ในอีเมลนี้${'\n'}${'\n'}กรุณาคลิกที่ไฟล์แนบ เพื่อดาวน์โหลดเอกสารของคุณ${'\n'}${'\n'}ท่านสามารถชำระค่าใช้จ่ายและดูรายงานการเก็บขนได้โดยผ่านลิงค์ดังกล่าว${'\n'}
        ${this.$global_link}/Customer/${TableData.CUSTOMER_ID}${'\n'}${'\n'}ท่านสามารถแอดไลน์เพื่อติดตามการเก็บขนได้โดยคลิ๊กลิงค์ดังกล่าว${'\n'}https://line.me/R/oaMessage/@328royru/link_${TableData.CUSTOMER_ID}${'\n'}${'\n'}ด้วยความเคารพ ${this.$AppName.limited_company}`
        this.apiUrl = `/send-bill-email`
        this.email_obj = {
          BILL_ID: TableData.BILL_ID,
          email_sender: this.Esender,
          email_reciever: this.Ereciever,
          email_header: this.Eheader,
          email_content: this.Emessage,
          pdf_file: "",
          file_name: ""
        }
      } else if (this.Page == 'Contract') {
        this.header = `สัญญา ${TableData.CONTRACT_ID}`
        this.Ereciever = TableData.PROVIDER_EMAIL
        this.Eheader = `เอกสารสัญญาเก็บขนมูลฝอยติดเชื้อ ${TableData.CONTRACT_ID}`
        this.Emessage = `เรียน  ${TableData.CUSTOMER_NAME}${'\n'}${'\n'}${this.$AppName.limited_company} ได้แนบเอกสาร เลขที่ ${TableData.CONTRACT_ID} มาให้ในอีเมลนี้${'\n'}${'\n'}กรุณาคลิกที่ไฟล์แนบ เพื่อดาวน์โหลดเอกสารของคุณ${'\n'}${'\n'}ท่านสามารถชำระค่าใช้จ่ายและดูรายงานการเก็บขนได้โดยผ่านลิงค์ดังกล่าว${'\n'} 
        ${this.$global_link}/Customer/${TableData.NEWCUSTOMER_ID}${'\n'}${'\n'}ท่านสามารถแอดไลน์เพื่อติดตามการเก็บขนได้โดยคลิ๊กลิงค์ดังกล่าว${'\n'}https://line.me/R/oaMessage/@328royru/link_${TableData.NEWCUSTOMER_ID}${'\n'}${'\n'} ด้วยความเคารพ ${this.$AppName.limited_company}`
        this.apiUrl = `/send-contract-email`
        this.email_obj = {
          CONTRACT_ID: TableData.CONTRACT_ID,
          email_sender: this.Esender,
          email_reciever: this.Ereciever,
          email_header: this.Eheader,
          email_content: this.Emessage,
          pdf_file: "",
          file_name: ""
        }

      } else if (this.Page == 'Invoice') {
        this.header = `ใบกำกับภาษี ${TableData.INVOICE_ID}`
        this.Ereciever = TableData.PROVIDER_EMAIL
        this.Eheader = `เอกสารกำกับภาษี ${TableData.INVOICE_ID}`
        this.Emessage = `เรียน  ${TableData.CUSTOMER_NAME}${'\n'}${'\n'}${this.$AppName.limited_company} ได้แนบเอกสาร เลขที่ ${TableData.INVOICE_ID} มาให้ในอีเมลนี้${'\n'}${'\n'}กรุณาคลิกที่ไฟล์แนบ เพื่อดาวน์โหลดเอกสารของคุณ${'\n'}${'\n'}ท่านสามารถชำระค่าใช้จ่ายและดูรายงานการเก็บขนได้โดยผ่านลิงค์ดังกล่าว${'\n'} 
        ${this.$global_link}/Customer/${TableData.NEWCUSTOMER_ID}${'\n'}${'\n'}ท่านสามารถแอดไลน์เพื่อติดตามการเก็บขนได้โดยคลิ๊กลิงค์ดังกล่าว${'\n'}https://line.me/R/oaMessage/@328royru/link_${TableData.NEWCUSTOMER_ID}${'\n'}${'\n'} ด้วยความเคารพ ${this.$AppName.limited_company}`
        this.apiUrl = `/send-invoice-email`
        this.email_obj = {
          INVOICE_ID: TableData.INVOICE_ID,
          email_sender: this.Esender,
          email_reciever: this.Ereciever,
          email_header: this.Eheader,
          email_content: this.Emessage,
          pdf_file: "",
          file_name: ""
        }
      }

    },
    closeModal() {
      this.dialog = false
    },
    sendemail() {
      let send_obj = this.email_obj
      send_obj.email_sender = this.Esender
      send_obj.email_reciever = this.Ereciever
      send_obj.email_header = this.Eheader
      send_obj.email_content = this.Emessage
      this.LOADER(true)
      this.$token_api.post(this.apiUrl, send_obj)
        .then((response) => {
          this.$swal({
            title: "สำเร็จ",
            text: "ส่งอีเมลสำเร็จ",
            timer: 2000,
            icon: "success"
          }).then((res) => {
            this.LOADER(false)
            this.dialog = false
          })
        }).catch((err) => {
          this.$swal("กรุณาลองใหม่อีกครั้ง", "เกิดข้อผิดพลาด", "error");
          this.LOADER(false)
        });
    }
  },
};
</script>